export default __webpack_public_path__ + "static/media/screen8.4a247901.png";